(function ($) {
	const $containers = $('.js-options-container');

	if (!$containers.length) {
		return;
	}

	let is_mobile_view = window.innerWidth < 968;

	function updateMobileView() {
		is_mobile_view = window.innerWidth < 968;
	}

	window.addEventListener('resize', debounce(updateMobileView, 100));

	$containers.each(setUpContainer);

	function setUpContainer() {
		const $container = $(this);
		const only_mobile = $container.attr('data-options-container-mobile-only') === 'true';
		const labelledBy = $container.attr('aria-labelledby');

		if (!labelledBy) {
			return;
		}

		const $label = $(`#${labelledBy}`);

		if (!$label.length) {
			return;
		}

		// if $container has id, use that, otherwise create one
		const id = $container.attr('id') || `options-container-${Math.floor(Math.random() * 100000)}`;

		// add id to $container
		$container.attr('id', id);

		// replace the label with a button, keep its original attributes and text
		const $button = $(`<button class="options-trigger" aria-expanded="true" controls="${id}">`)
			.html($label.html())
			.insertBefore($label);

		$container.data('button', $button);

		// copy the label's class and id to the button
		$button.addClass($label.attr('class')).attr('id', $label.attr('id'));

		$label.remove();

		$button.on('click', toggleContainer);

		// collapse the button if the $container has no input:checked
		if (
			!$container.find('input:checked').length ||
			($container.is('[close-initial]') && !$container.is('[open-initial]'))
		) {
			// $button.attr('aria-expanded', false);
			// $container.attr('aria-hidden', true);
			$container.hide();
			toggleContainer({ preventDefault: () => {} });
		}

		if (only_mobile) {
			window.addEventListener(
				'resize',
				debounce(() => {
					if (is_mobile_view) {
						$button.show();
					} else {
						$button.hide();
						// make sure it's expanded
						const expanded = $button.attr('aria-expanded') === 'true';

						if (!expanded) {
							$container.show();
							$container.attr('aria-hidden', false);
						}
					}
				}, 200),
			);

			// trigger a resize event to hide the button if necessary
			window.dispatchEvent(new Event('resize'));
		}

		function closeAll(e) {
			// if event was not inside the container, close all
			const clickedInside = $(e.target).closest('.option-select-group').length;
			if (!clickedInside) {
				const $open = $containers.filter('[aria-hidden="false"]');

				if ($open.length) {
					$open.each((i, el) => {
						$(el).slideUp(200).attr('aria-hidden', true);
						$(el).data('button').attr('aria-expanded', false);
					});
				}
			}
		}

		function toggleContainer(e) {
			e.preventDefault();

			if ((is_mobile_view && only_mobile) || !only_mobile) {
				const expanded = $button.attr('aria-expanded') === 'true';
				$button.attr('aria-expanded', !expanded);

				if (expanded) {
					$container.slideUp(200);
					$('body').off('click', closeAll);
				} else {
					$('body').on('click', closeAll);
					$container.slideDown(300);

					if ($container.is('[one-open]')) {
						const $another = $containers.not($container);

						if ($another.length) {
							$another.slideUp(200).attr('aria-hidden', true);
							$another.data('button').attr('aria-expanded', false);
						}
					}
				}

				$container.attr('aria-hidden', expanded);
			}
		}
	}
})(jQuery);
